export const SUPPORTED_SHAPES = [
  "circle",
  "hexagon",
  "star-8",
  "diamond",
  "blobby-star",
  "heart",
  "club",
  "spade",
];

export const bgToTextColor: Record<string, string> = {
  "#F44336": "#fff",
  "#9C27B0": "#fff",
  "#2196F3": "#fff",
  "#4CAF50": "#fff",
  "#FFEB3B": "#000",
  "#FF5722": "#fff",
  "#9E9E9E": "#fff",
  "#3F51B5": "#fff",
  "#E91E63": "#fff",
  "#673AB7": "#fff",
  "#CDDC39": "#000",
  "#795548": "#fff",
  "#607D8B": "#fff",
  "#FFC107": "#000",
  "#009688": "#fff",
};
